// import config
import axios, { handleResp } from '../config/axios'



export const getSptCat = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `api/user/getSupportCategory`,
            'data': data
        });

        return {
            status: "success",
            loading: false,
            result: respData.data.result,
            message: respData.data.message,
        }
    }
    catch (err) {
        handleResp(err, 'error')
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
        }
    }
}

export const getTicketList = async (data) => {
    try {
        let respData = await axios({
            method: "get",
            url: `api/user/support`,
            params: data
        });
        return {
            status: "success",
            loading: false,
            result: respData.data.result,
        };
    } catch (err) {
        handleResp(err, 'error')
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
        };
    }
};

export const createNewTicket = async (data) => {
    try {
        let respData = await axios({
            method: "post",
            url: `api/user/support`,
            data,
        });
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
        };
    } catch (err) {
        handleResp(err, 'error')
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors,
        };
    }
};


export const replyMessage = async (data) => {
    try {
        let respData = await axios({
            method: "put",
            url: `api/user/support`,
            data,
        });
        return {
            status: "success",
            loading: false,
            result: respData.data.result,
            message: respData.data.message,
        };
    } catch (err) {
        handleResp(err, 'error')
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors,
        };
    }
};

export const closeTicket = async (data) => {
    try {
        let respData = await axios({
            method: "patch",
            url: `api/user/support`,
            data,
        });
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result,
        };
    } catch (err) {
        handleResp(err, 'error')
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors,
        };
    }
};
